module.exports = __webpack_public_path__ + "images/e4a3aeee3ce98bcc08f535dae056b22a.png";